/**
 * Created by scuzzort3 on 7/31/17.
 */
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.hierarchy', {
                url: '/hierarchy',
                controller: 'HierarchyController',
                controllerAs: 'vm',
                templateUrl: 'app/components/hierarchy/hierarchy.view.html'
            });
    }
})();